<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { vodafoneLabBasicMixin } from '../../modules/vodafone_lab_mixins_module.js';
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin, vodafoneLabBasicMixin],
  props: {
    width: {
      type: Number,
      default: 7
    }
  },
  data: function () {
    return {};
  },
  computed: {
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : this.width;
      return [
        `col-lg-${columnWidth}`,
      ];
    },
  },
  methods: {
    expandUrl: Fandom.expandUrl,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getTarget: Fandom.getTarget,
  }
};
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    :class="contentType"
    class="py-4 py-md-5"
    v-if="isContentVisibleToUser()" 
    stripe-cta-component
    :id="content.name"
  >
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12" :class="columnClasses">
          <a :href="content.url.url" :target="getTarget(content.url)" class="px-4 py-3 d-flex align-items-center justify-content-between tile-shadow deco-none" v-if="content.url">
            <div class="h5 font-weight-bold mb-0">{{content.url.title}}</div>
            <i class="fal fa-chevron-right fa-2x"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-cta-component] {
  .tile-shadow {
    border-radius: .5rem;
  }
}

</style>